module.exports = __webpack_public_path__ + "static/hero-wts-b1ea397f143068f4406d3a85d6b821c0.webp";